<div class="d-flex">
    <label class="mr-2">Payment Method:</label>
    <label class="mr-2">
        <mat-checkbox (change)="filters.check = !filters.check" [checked]="filters.check">
            Paper Check
        </mat-checkbox>
    </label>
    <label class="mr-2">
        <mat-checkbox (change)="filters.cash = !filters.cash" [checked]="filters.cash">
            Cash
        </mat-checkbox>
    </label>
    <label class="mr-2">
        <mat-checkbox (change)="filters.bank = !filters.bank" [checked]="filters.bank">
            Bank Account
        </mat-checkbox>
    </label>
    <label class="mr-2">
        <mat-checkbox (change)="filters.card = !filters.card" [checked]="filters.card">
            Credit Card
        </mat-checkbox>
    </label>
    <label class="mr-2">
        <mat-checkbox (change)="filters.credit = !filters.credit" [checked]="filters.credit">
            Account Credit
        </mat-checkbox>
    </label>
</div>
